/**
 * CUSTOMIZATIONS:
 * removed attributes footer color and discreet Segment
 * added FooterSmall and FooterSmall
 **/

/**
 * Footer component.
 * @module components/theme/Footer/FooterSmall
 */

import React from 'react';
import { Container, List, Segment } from 'semantic-ui-react';
import { map } from 'lodash';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers';
import {
  FooterSmallLeft,
  FooterSmallCenter,
  FooterSmallRight,
} from '@redturtle/volto-io-studio/components/Layout';

//  const messages = defineMessages({
//    copyright: {
//      id: 'Copyright',
//      defaultMessage: 'Copyright',
//    },
//  });

/**
 * Component to display the small footer under the main footer.
 * @function FooterSmall
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const FooterSmall = ({ intl }) => {
  return (
    <Segment role="contentinfo" vertical id="sub-footer" aria-label="Footer">
      <Container>
        <FooterSmallLeft />
        <FooterSmallCenter />
        <FooterSmallRight />
      </Container>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
FooterSmall.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(FooterSmall);
